<script>
	import { Tabs, Tab, TabList, TabPanel } from './tabs';
	import { register, addMessages, init, getLocaleFromNavigator, _ } from 'svelte-i18n';
	import Background from './Background.svelte';
	import Footer from './Footer.svelte';
	import Language from './Language.svelte';
	import * as Panels from './panels';
	import { fly } from 'svelte/transition';
	import pl from './dict/pl.json';
	import en from './dict/en.json';

	addMessages('pl', pl);
	addMessages('en', en);

	init({
			fallbackLocale: 'en',
		});

	const panel_list = [
			{ panel_text_key: "about", panel_icon: ' <i class="fa fa-info-circle"></i>', component: Panels.About},
			{ panel_text_key: "goal", panel_icon: ' <i class="fa fa-bullseye"></i>', component: Panels.Goal},
			{ panel_text_key: "contact", panel_icon: ' <i class="fa fa-phone">', component: Panels.Contact}
		];
	let lang;

</script>

<Background/>
<main>
	<Language bind:selected={lang}/>

	<h1>
		<span>AION</span> <br>
		<span class="white">P</span><span style="font-size: 0.6em">oo</span><span class="red">L</span>
	</h1>
	<h2>{$_("pt_location")} <i class="fa fa-heart" style="color: red"></i><br> {$_("pt_description")}</h2>

	<Tabs>
		<TabList>
			{#each panel_list as panel}
				<Tab id={panel.panel_text_key}>{@html $_(panel.panel_text_key) + panel.panel_icon}</Tab>
			{/each}
		</TabList>

		{#each panel_list as panel}
			<TabPanel>
				<div> 
					<svelte:component this={panel.component}/>
				</div>
			</TabPanel>
		{/each}
	</Tabs>
</main>
<Footer/>

<style>
	main {
		flex: 1;
		text-align: center;
		padding: 1rem;
		max-width: 840px;
		/*footer heigh*/
		min-height: calc(100vh - 146px);
	}

	div {
		margin: auto;
		max-width: 1000px;
		background-color: RGBA(0,0,0,0.6);
		border-radius: 25px;
		box-shadow: 0px 0px 15px 15px RGBA(0,0,0,0.6);
		color: #BBBBBB;
	}

	h2 {
		color: #aaa9ad;
		margin-top: 0px;
		margin-bottom: 35px;
	}

	h1 span {
		background-color: #d7d7d7;
		background-image: linear-gradient(147deg, hsl(340, 60%, 60%), hsl(210, 60%, 60%));
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		background-clip: text;
	}

	h1 {
		text-transform: uppercase;
		font-size: 6em;
		font-weight: 100;
		font-family: aquire-font-bold;
		margin-bottom: 15px;
	}

	.red {
		background: linear-gradient(to top right, #D4213D 0%, #a62c2b 100%);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		background-clip: text;
	}

	.white {
		background: linear-gradient(to top right, #E9E8E7 0%, #aaa9ad 100%);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		background-clip: text;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>
